<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false">
			<!--控件添加修改-->
			<Form :rules="ruleInline" label-position="right" ref="refForm" :model="modalInfo" :label-width="150">
				<Row :gutter="24" style="margin-bottom: 10px;" v-show="false">
					<Col span=12>
					<FormItem label="优惠券发行ID" prop="IssueId">
						<Input :disabled="modal.canInput" v-model="modalInfo.IssueId" placeholder="优惠券发行ID"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="ModifyBy" prop="ModifyBy">
						<Input :disabled="modal.canInput" v-model="modalInfo.ModifyBy" placeholder="ModifyBy"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="CreateBy" prop="CreateBy">
						<Input :disabled="modal.canInput" v-model="modalInfo.CreateBy" placeholder="CreateBy"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="优惠券发行状态" prop="IssueStatus">
						<Select :disabled="modal.canInput" placeholder="优惠券发行状态" v-model="modalInfo.IssueStatus">
							<Option :value='0'>未发行</Option>
							<Option :value='1'>已发行</Option>
							<Option :value='99'>已撤回</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col span=12>
					<FormItem label="优惠券类型" prop="CouponType">
						<Select :disabled='true' placeholder="优惠券类型" v-model="modalInfo.CouponType">
							<Option :value='1'>满减金额</Option>
							<Option :value='2'>满减折扣</Option>
							<Option :value='3'>随机立减</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="优惠券名称" prop="ConponName">
						<Input :disabled="modal.canInput" v-model="modalInfo.ConponName" placeholder="优惠券名称"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="优惠券描述" prop="ConponDesc">
						<Input :disabled="modal.canInput" v-model="modalInfo.ConponDesc" placeholder="优惠券描述"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<!-- <Col span=12>
					<FormItem label="剩余数量" prop="RemainNum">
						<Input :disabled='true' v-model="modalInfo.RemainNum" number placeholder="剩余数量"></Input>
					</FormItem>
					</Col> -->
					<Col span=12>
					<FormItem label="发行数量" prop="CouponNum">
						<Input :disabled="modal.canInput" v-model="modalInfo.CouponNum" number
							placeholder="发行数量"></Input>
					</FormItem>
					</Col>
					<Col span=12 v-if="modal.type=='add3'">
					<FormItem label="发行总金额" prop="CouponTotalAmount">
						<Input :disabled="modal.canInput" v-model="modalInfo.CouponTotalAmount" number
							placeholder="发行总金额"></Input>
					</FormItem>
					</Col>
				</Row>
				<!-- <Row :gutter="24">
					<Col span=12>
					<FormItem label="剩余金额" prop="RemainTotalAmount">
						<Input :disabled='true' v-model="modalInfo.RemainTotalAmount" number placeholder="剩余金额"></Input>
					</FormItem>
					</Col>
				</Row> -->
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="消费金额达到设定值" prop="RequireAmount">
						<Input :disabled="modal.canInput" v-model="modalInfo.RequireAmount"
							placeholder="消费金额达到设定值"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="modalInfo.CouponType == 2 ? '优惠折扣' : modalInfo.CouponType == 3 ? '随机金额范围' : '优惠金额'" prop="CouponAmount">
						<Input :disabled="modal.canInput" v-model="modalInfo.CouponAmount" placeholder="优惠金额"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="优惠券生效时间" prop="StartTime">
						<DatePicker type="datetime" placeholder="优惠券生效时间" v-model="modalInfo.StartTime"></DatePicker>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="优惠券失效时间" prop="EndTime">
						<DatePicker type="datetime" placeholder="优惠券失效时间" v-model="modalInfo.EndTime"></DatePicker>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="领取间隔时间(天)" prop="SpanTime">
						<Input :disabled="modal.canInput" v-model="modalInfo.SpanTime" number
							placeholder="优惠券领取间隔时间(天)"></Input>
					</FormItem>
					</Col>
					<!-- <Col span=12>
					<FormItem label="能否与其他优惠券同时使用" prop="IsExclusive">
						<i-switch :disabled="modal.canInput" :true-value='1' :false-value='0'
							v-model="modalInfo.IsExclusive" size="large">
							<span slot="open">是</span>
							<span slot="close">否</span>
						</i-switch>
					</FormItem>
					</Col> -->
				</Row>
				<!-- <Row :gutter="24">
					<Col span=12 v-show="false">
					<FormItem label="限定商户" prop="CollectionMch">
						<Input :disabled="modal.canInput" v-model="modalInfo.CollectionMch" placeholder="限定商户"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="支付方式" prop="PaymentMode">
						<Select placeholder="支付方式" v-model="modalInfo.PaymentMode">
							<Option v-bind:key="item.Id" v-for="(item) in PaymentMode" :value="item.Id">{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col>
				</Row> -->
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="运营商Id" prop="OperatorId">
						<Input :disabled='true' v-model="modalInfo.OperatorId" placeholder="运营商Id"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="限定场站" prop="StationArray">
						<Select filterable :max-tag-count='4' placeholder="限制场站" multiple v-model="modalInfo.StationArray">
							<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in StationList" :value="item.StationId">{{item.StationName}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<!-- <Row :gutter="24">
					<Col span=12>
					<FormItem label="建档人" prop="Creator">
						<Input :disabled='true' v-model="modalInfo.Creator" placeholder="建档人"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="建档时间" prop="CreateTime">
						<Input :disabled='true' v-model="modalInfo.CreateTime" placeholder="建档时间"></Input>
					</FormItem>
					</Col>
				</Row> -->
				<!-- <Row :gutter="24">
					<Col span=12>
					<FormItem label="修改人" prop="Modifier">
						<Input :disabled='true' v-model="modalInfo.Modifier" placeholder="修改人"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="修改时间" prop="ModifyTime">
						<Input :disabled='true' v-model="modalInfo.ModifyTime" placeholder="修改时间"></Input>
					</FormItem>
					</Col>
				</Row> -->
			</Form>
			<div v-if="modal.type!='up'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">取消</Button>
				<Button type="success" size="large" @click="modalOk('add')">添加</Button>
			</div>
			<div v-if="modal.type=='up'" slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">取消</Button>
				<!-- <Button type="success" @click="modalOk('up')" size="large">修改</Button> -->
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			const validateOpId = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('输入运营商Id'));
				} else {
					if (this.modalInfo.OperatorId.length !== 9) {
						callback(new Error('输入社会信用代码码第9~倒数第2位'));
					}
					callback();
				}
			};
			return {
				modal: {
					Title: "用户添加",
					type: "add",
					ifShow: false,
					canInput: false
				},
				//添加会员model
				modalInfo: {
					// Id
					// 角色名字
					// 角色描述
					// 操作者Id
					"IssueId": "",
					"CouponType": 0,
					"ConponName": "",
					"ConponDesc": "",
					"CouponNum": 0,
					"RemainNum": 0,
					"CouponTotalAmount": 0,
					"RemainTotalAmount": 0,
					"IssueStatus": 0,
					"RequireAmount": "",
					"CouponAmount": "",
					"StartTime": dateFormat.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
					"EndTime": dateFormat.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
					"SpanTime": 0,
					"IsExclusive": 0,
					"CollectionMch": 0,
					"PaymentMode": 0,
					"OperatorId": "",
					"StationList": "",
					"CreateBy": 0,
					"CreateTime": dateFormat.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
					"ModifyBy": 0,
					"ModifyTime": dateFormat.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
					"Creator": "",
					"Modifier": "",
					"IsEdit": false
				},
				//校验字段
				ruleInline: {
					ConponName: [{
						required: true,
						message: '请输入优惠券名称',
						trigger: 'blur',
						//type: 'number',
					}],
					CouponNum: [{
						required: true,
						message: '请输入发行数量',
						trigger: 'blur',
						type: 'number',
					}],
					// RemainNum: [{
					// 	required: true,
					// 	message: '请输入剩余数量',
					// 	trigger: 'blur',
					// 	type: 'number',
					// }],
					// CouponTotalAmount: [{
					// 	required: true,
					// 	message: '请输入发行总金额',
					// 	trigger: 'blur',
					// 	type: 'number',
					// }],
					// RemainTotalAmount: [{
					// 	required: true,
					// 	message: '请输入剩余金额',
					// 	trigger: 'blur',
					// 	type: 'number',
					// }],
					RequireAmount: [{
						required: true,
						message: '请输入前提条件',
						trigger: 'blur',
						type: 'number',						
					}],
					CouponAmount: [{
						required: true,
						message: '请输入优惠内容',
						trigger: 'blur',
						type: 'number',						
					}],
					StartTime: [{
						required: true,
						message: '请输入优惠券生效时间',
						trigger: 'blur',
						type: 'date',
					}],
					EndTime: [{
						required: true,
						message: '请输入优惠券失效时间',
						trigger: 'blur',
						type: 'date',
					}],
				},
			};
		},
		methods: {
			//打开新增会员
			show: function(type, params) {
				const _this = this;
				switch (type) {
					case "add1":
						console.log(_this.modal);
						_this.modal.Title = "满减券添加";
						_this.modal.type = "add1";
						_this.$refs.refForm.resetFields()
						_this.modalInfo.IsEdit = false
						// _this.modalInfo.RequireAmount = '50'
						// _this.modalInfo.CouponAmount = '1'
						_this.modalInfo.CouponType = 1
						break;
					case "add2":
						_this.modal.Title = "折扣券添加";
						_this.modal.type = "add2";
						_this.$refs.refForm.resetFields()
						_this.modalInfo.IsEdit = false
						// _this.modalInfo.RequireAmount = '0'
						// _this.modalInfo.CouponAmount = '0.98'
						_this.modalInfo.CouponType = 2
						break;
					case "add3":
						_this.modal.Title = "随机立减券添加";
						_this.modal.type = "add3";
						_this.$refs.refForm.resetFields()
						_this.modalInfo.IsEdit = false
						// _this.modalInfo.RequireAmount = '0'
						// _this.modalInfo.CouponAmount = '1~2'
						_this.modalInfo.CouponType = 3
						break;
					case "up":
						_this.modal.Title = "优惠券查看";
						_this.modal.type = "up";
						_this.modalInfo = {
							"IssueId": params.IssueId,
							"CouponType": params.CouponType,
							"ConponName": params.ConponName,
							"ConponDesc": params.ConponDesc,
							"CouponNum": params.CouponNum,
							"RemainNum": params.RemainNum,
							"CouponTotalAmount": params.CouponTotalAmount,
							"RemainTotalAmount": params.RemainTotalAmount,
							"IssueStatus": params.IssueStatus,
							"RequireAmount": params.RequireAmount,
							"CouponAmount": params.CouponAmount,
							"StartTime": params.StartTime,
							"EndTime": params.EndTime,
							"SpanTime": params.SpanTime,
							"IsExclusive": params.IsExclusive,
							"CollectionMch": params.CollectionMch,
							"PaymentMode": params.PaymentMode,
							"OperatorId": params.OperatorId,
							"StationList": params.StationList,
							"StationArray": params.StationArray,
							"CreateBy": params.CreateBy,
							"CreateTime": params.CreateTime,
							"ModifyBy": params.ModifyBy,
							"ModifyTime": params.ModifyTime,
							"Creator": params.Creator,
							"Modifier": params.Modifier,
							"IsEdit": true
						};
						break;
					default:
						break;
				}
				_this.modal.ifShow = true
			},
			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addAndUp('add');
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addAndUp('up');
						break;
					default:
						break;
				}
			},
			//添加
			addAndUp: function(type) {
				const _this = this;
				_this.$refs.refForm.validate((valid) => {
					console.log("优惠券" + type + "----" + valid)
					if (valid) {
						let parms = _this.modalInfo
						_this.$axios.post(webapi.base_api_url + "/Operations/AddCouponIssue", parms, {}).then(
							res => {
								console.log("新增优惠券")
								console.log(res.data)
								if (res.data.Code == 0) {
									this.$Message.success('优惠券添加成功');
									_this.$emit('handleSubmit');
									_this.modalOk("cancle")
								} else {
									this.$Message.success(res.data.Msg + "---" + res.data.Data);
								}
							})
					}
				})
			},
		},
		watch: {
			'modalInfo.CouponNum'(val) {
				this.modalInfo.RemainNum = val
			},
			'modalInfo.CouponTotalAmount'(val) {
				this.modalInfo.RemainTotalAmount = val
			}
		},
		mounted() {

		},
		computed: {
			//直接选属性
			...mapState({
				PaymentMode: 'PaymentMode',
				StationList: 'Stations',
				RoleList: 'roleList',
				OperatortypeList: 'typeList'
			})
		}
	}
</script>

<style>
</style>
